export const EMAIL_CONTACT_LINK = 'mailto:info@momentshare.io'
export const WHATSAPP_CONTACT_LINK = 'https://wa.me/+31617387177'
